import Alpine from 'alpinejs';

Alpine.data('zipCodeToOfficeInput', (type, forceCountry, redirectUrl) => ({
    country: forceCountry || '',
    product: '',
    postalCode: '',
    countryRequiresPostalCode: !!forceCountry,
    showCountryError: false,
    type: type, // 'choice' or 'airFreight' or 'oceanFreight'
    disableProduct: false,
    init() {
        if (!forceCountry) {
            const searchParams = new URLSearchParams(window.location.search);
            const urlProduct = searchParams.get('product');
            if (urlProduct) {
                this.product = urlProduct;
            }
            const urlCountry = searchParams.get('country');
            if (urlCountry) {
                this.country = urlCountry;
                // trigger map to select country
                setTimeout(() => this.selectCountry(urlCountry), 300);
            }
        }
        this.$watch('country', (country) => {
            this.postalCode = '';
            this.showCountryError = false;
            this.countryRequiresPostalCode = false;
            if (forceCountry && country !== forceCountry) {
                const productUriPart = this.product || type ? '&product=' + (this.product || type) : '';
                window.location.href = redirectUrl + '?country=' + country + productUriPart + '#world-map';
            }
            this.selectCountry(country);
        });
        this.$watch('product', (product) => {
            if (product) {
                this.selectCountry(this.country);
                this.selectPostalCode();
            }
        });
    },
    selectPostalCode() {
        this.showCountryError = false;
        if (!this.postalCode) {
            return;
        }
        let city = this.getCityByPostalCode();
        if (city) {
            // city to city object
            city = { country: this.country, city: city };
        }
        if (!city) {
            // let's see if just the country is enough
            city = this.getCityFromCountry(this.country);
        }
        if (city) {
            this.$dispatch('selectCity', city);
            this.product = '';
            this.postalCode = '';
        }
    },
    selectCountry(country) {
        let city = this.getCityFromCountry(country);
        if (city) {
            this.$dispatch('selectCity', city);
        } else {
            this.$dispatch('selectCountry', { country: country });
            this.countryRequiresPostalCode = true;
            setTimeout(() => {
                if (!this.product) {
                    this.$root.querySelector('select[x-model="product"]').focus();
                    return;
                }
                if (!this.postalCode) {
                    this.$root.querySelector('input').focus();
                    return;
                }
            }, 100);
        }
        if (this.isSameOfficeForAirFreightAndOceanFreight(country)) {
            this.disableProduct = true;
            this.countryRequiresPostalCode = false;
            // Dispatch directly because product choice is irrelevant here
            const sameCity = this.getCityFromCountryForAirFreight(country);
            if (sameCity) this.$dispatch('selectCity', sameCity);
        } else {
            this.disableProduct = false;
        }
    },
    isSameOfficeForAirFreightAndOceanFreight(country) {
        const air = this.getCityFromCountryForAirFreight(country);
        const ocean = this.getCityFromCountryForOceanFreight(country);
        if (!air || !ocean) return false;
        return air.country === ocean.country && air.city === ocean.city;
    },
    getCityFromCountry(country) {
        const type = this.type === 'choice' ? this.product : this.type;
        switch (type) {
            case 'airFreight':
                return this.getCityFromCountryForAirFreight(country);
            case 'oceanFreight':
                return this.getCityFromCountryForOceanFreight(country);
            default:
                return null; // user needs to select product
        }
    },
    getCityFromCountryForAirFreight(country) {
        switch (country) {
            case 'Bosnia': // 71000–89819
            case 'Croatia': // 10000-52999
                return { country: 'Croatia', city: 'Zagreb', forCountry: country};
            case 'CzechRepublic': // 100 00 - 799 99
                return { country: 'CzechRepublic', city: 'Prague', forCountry: country };
            case 'Hungary': // 1000–9985
                return { country: 'Hungary', city: 'Budapest', forCountry: country };
            case 'Lithuania': // 01001–99999
                return { country: 'Poland', city: 'Warsaw', forCountry: country };
            case 'Belgium': // 1000-9999
            case 'Netherlands': // 1000-9999 (plus 2 Buchstaben)
            case 'Luxembourg': // L-1000 bis L-9999
            case 'Denmark': // 1000–9990
                return { country: 'Germany', city: 'Frankfurt am Main', forCountry: country };
            case 'Romania': // 010000–999999
            case 'Bulgaria': // 1000–9999
            case 'Moldova': // MD-2000–MD-6900
                return { country: 'Romania', city: 'Bucharest', forCountry: country };
            case 'Serbia': // 11000–39999
            case 'Montenegro': // 81000–85360
            case 'Albania': // 1000-9706
            case 'Macedonia': // 1000-7500
            case 'Kosovo': // 10000-38850
                return { country: 'Serbia', city: 'Belgrade', forCountry: country };
            case 'Slovakia': // 010 01 – 999 99
                return { country: 'Slovakia', city: 'Bratislava', forCountry: country };
            case 'Slovenia': // Büro: Ljubljana 1000–9265
                return { country: 'Slovenia', city: 'Ljubljana', forCountry: country };
            case 'Switzerland': // 1000–9658
            case 'Liechtenstein': // 9485–9499
                return { country: 'Switzerland', city: 'Zurich', forCountry: country };
            case 'Ireland':
            case 'UnitedKingdom': // AB1–ZE3
                return { country: 'UnitedKingdom', city: 'London', forCountry: country };
            case 'China': // 100000–999999
                return { country: 'China', city: 'Shanghai', forCountry: country };
            case 'Ukraine': // 01000–99999
                return { country: 'Ukraine', city: 'Kyiv', forCountry: country };
            default:
                return null;
        }
    },
    getCityFromCountryForOceanFreight(country) {
        switch (country) {
            case 'Austria':
                return { country: 'Austria', city: 'Vienna', forCountry: country };
            case 'Bosnia':
            case 'Croatia':
                return { country: 'Croatia', city: 'Zagreb', forCountry: country };
            case 'CzechRepublic':
                return { country: 'CzechRepublic', city: 'Prague', forCountry: country };
            case 'Belgium':
                return { country: 'Germany', city: 'Frankfurt am Main', forCountry: country };
            case 'Germany':
                return { country: 'Germany', city: 'Hamburg', forCountry: country };
            case 'Hungary':
                return { country: 'Hungary', city: 'Budapest', forCountry: country };
            case 'Romania': // 010000–999999
            case 'Bulgaria': // 1000–9999
            case 'Moldova': // MD-2000–MD-6900
                return { country: 'Romania', city: 'Bucharest', forCountry: country };
            case 'Lithuania': // 01001–99999
                return { country: 'Poland', city: 'Wroclaw', forCountry: country };
            case 'Serbia': // 11000–39999
            case 'Montenegro': // 81000–85360
            case 'Albania': // 1000-9706
            case 'Macedonia': // 1000-7500
            case 'Kosovo': // 10000-38850
                return { country: 'Serbia', city: 'Belgrade', forCountry: country };
            case 'Slovakia':
                return { country: 'Slovakia', city: 'Bratislava', forCountry: country };
            case 'Slovenia':
                return { country: 'Slovenia', city: 'Koper', forCountry: country };
            case 'Switzerland':
            case 'Lichtenstein':
                return { country: 'Switzerland', city: 'Zurich', forCountry: country };
            case 'Ireland':
            case 'UnitedKingdom':
                return { country: 'UnitedKingdom', city: 'London', forCountry: country };
            case 'Ukraine':
                return { country: 'Ukraine', city: 'Kyiv', forCountry: country };
            case 'China':
                return { country: 'China', city: 'Shanghai', forCountry: country };
            default:
                return null;
        }
    },
    getCityByPostalCode() {
        const type = this.type === 'choice' ? this.product : this.type;
        switch (type) {
            case 'airFreight':
                return this.getCityByPostalCodeForAirFreight(this.country, this.postalCode);
            case 'oceanFreight':
                return this.getCityByPostalCodeForOceanFreight(this.country, this.postalCode);
        }
    },
    getCityByPostalCodeForAirFreight(country, postalCode) {
        switch (country) {
            case 'Germany':
                return getGermanCityForAirFreight(postalCode);
            case 'Austria':
                return getAustrianCityForAirFreight(postalCode);
            case 'Poland':
                return getPolishCityForAirFreight(postalCode);
            default:
                return;
        }
    },
    getCityByPostalCodeForOceanFreight(country, postalCode) {
        switch (country) {
            case 'Poland':
                return getPolishCityForOceanFreight(postalCode);
            default:
                return null;
        }
    },
}));

function getAustrianCityForAirFreight(postalCode) {
    const numericCode = parseInt(postalCode, 10);
    // Postal codes explicitly mapped to Vienna
    const viennaCodes = [
        1010, 1020, 1030, 1040, 1050, 1060, 1070, 1080, 1090, 1100, 1110, 1120, 1130, 1140, 1150, 1160, 1170, 1180,
        1190, 1200, 1210, 1220, 1230, 2333,
    ];

    // Check for Vienna
    if (viennaCodes.includes(numericCode)) return 'Vienna';
    if ((numericCode >= 2000 && numericCode <= 3998) || (numericCode >= 7000 && numericCode <= 7599)) {
        return 'Vienna';
    }

    // Check for Graz
    if ((numericCode >= 8000 && numericCode <= 8999) || (numericCode >= 9000 && numericCode <= 9999)) {
        return 'Graz';
    }

    // Check for Linz
    if (
        (numericCode >= 4000 && numericCode <= 4999) ||
        (numericCode >= 5000 && numericCode <= 5999) ||
        (numericCode >= 6000 && numericCode <= 6999)
    ) {
        return 'Linz';
    }

    // If you want Innsbruck or Salzburg:
    // if (/* some postalCode check */) return "Innsbruck";
    // if (/* some postalCode check */) return "Salzburg";

    return 'Vienna'; // fallback
}

function getPolishCityForAirFreight(postalCode) {
    // Correctly with hyphen XX-XXX, but might also be XXXXX
    const codeStr = postalCode.trim();
    if (!codeStr) return 'Warsaw'; // fallback

    // Wroclaw: first digit 5,6,7
    // Warsaw: first digit 0,1,2,3,4,8,9
    const firstDigit = codeStr.charAt(0);
    if (['5', '6', '7'].includes(firstDigit)) {
        return 'Wroclaw';
    }
    return 'Warsaw'; // Default
}

function getGermanCityForAirFreight(postalCode) {
    const code = parseInt(postalCode, 10);
    if (isNaN(code)) return null;

    // FrankfurtAmMain
    if (
        (code >= 1000 && code <= 19999) ||
        (code >= 34000 && code <= 39999) ||
        (code >= 54000 && code <= 56999) ||
        (code >= 60000 && code <= 69999) ||
        (code >= 76000 && code <= 76299) ||
        (code >= 76600 && code <= 76999) ||
        (code >= 95000 && code <= 99999)
    ) {
        return 'Frankfurt am Main';
    }

    // Dusseldorf
    if ((code >= 20000 && code <= 33999) || (code >= 40000 && code <= 53999) || (code >= 57000 && code <= 59999)) {
        return 'Dusseldorf';
    }

    // Stuttgart
    if (
        (code >= 70000 && code <= 75999) ||
        (code >= 76300 && code <= 76599) ||
        (code >= 77000 && code <= 79999) ||
        (code >= 88000 && code <= 89999)
    ) {
        return 'Stuttgart';
    }

    // Munich
    if ((code >= 80000 && code <= 87999) || (code >= 90000 && code <= 94999)) {
        return 'Munich';
    }

    // If no range matches, send to Hamburg
    return 'Hamburg';
}

// -------------------------------------------------------------------------------------------------

function getPolishCityForOceanFreight(postalCode) {
    const codeStr = postalCode.trim();
    if (!codeStr) return 'Warsaw'; // fallback

    const firstDigit = codeStr.charAt(0);
    const firstTwo = codeStr.substring(0, 2);

    // Gdynia: first digit=1, or first two digits in 75,76,77,78,79, or first digit=8
    if (firstDigit === '1' || ['75', '76', '77', '78', '79'].includes(firstTwo) || firstDigit === '8') {
        return 'Gdynia';
    }

    // Wroclaw: first two digits in 70,71,72,73,74, or first digit=5 or 6
    if (['70', '71', '72', '73', '74'].includes(firstTwo) || ['5', '6'].includes(firstDigit)) {
        return 'Wroclaw';
    }

    // Warsaw: first digit=0,2,3,4,9
    if (['0', '2', '3', '4', '9'].includes(firstDigit)) {
        return 'Warsaw';
    }

    return 'Warsaw'; // Fallback
}
